import React, { useRef, useState } from 'react'
import toast from 'react-hot-toast'
import { useNavigate } from 'react-router-dom'
import { otpVerification } from '../../Services/AuthServices'

const useOtpVerification = () => {


    const [otp, setOtp] = useState(["", "", "", ""]);
    const [isLoading, setIsLoading] = useState(false);
    const inputRefs = useRef([]);

    const handleOtp = (e, index) => {
        let value = e.target.value;

        if (value.length > 1) {
            value = value.slice(0, 1);
        }

        const newOtp = [...otp];
        newOtp[index] = value;

        setOtp(newOtp);
        if (value !== "" && index < otp.length - 1) {
            inputRefs.current[index + 1].focus();
        }
    };

    const navigate = useNavigate()

    const handleSubmit = async (e) => {
        e.preventDefault()
        setIsLoading(true)
        let response = await otpVerification({ email: localStorage.getItem("forgot_email"), code: otp.join('') })
        if (response.statusCode === 200) {
            localStorage.setItem("otp_code", otp.join(''))
            toast?.success(response?.response?.data)
            setIsLoading(false)
            navigate("/create-new-password")
        } else if (response.statusCode === 401) {
            toast?.error(response?.errors)
            setIsLoading(false)
        } else {
            for (const [key, value] of Object.entries(response?.errors)) {
                toast?.error(value)
            }
            setIsLoading(false)
        }
        setIsLoading(false)
    }


    return [
        otp,
        isLoading,
        inputRefs,
        handleOtp,
        handleSubmit,

    ]
}

export default useOtpVerification